import Matter from "matter-js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

class FooterAnimation {
    constructor(logoImageUrl = './assets/img/logo.jpg') {
        this.logoImageUrl = logoImageUrl;
        this.init();
    }

    init() {
        const elements = document.querySelectorAll('.animated-footer');
        elements.forEach(container => this.createInstance(container));
    }

    createInstance(container) {
        const engine = Matter.Engine.create();
        const world = engine.world;
        const renderData = {
            container,
            engine,
            world,
            logos: [],
            maxLogos: 20,
            activated: false
        };

        this.setupScrollTrigger(renderData);
    }

    setupScrollTrigger(data) {
        ScrollTrigger.create({
            trigger: data.container,
            start: 'top bottom',
            // markers: true,
            once: true,
            onEnter: () => {
                if (!data.activated) {
                    data.activated = true;
                    this.startAnimation(data);
                }
            }
        });
    }

    startAnimation(data) {
        this.setupRenderer(data);
        this.setupStaticObstacles(data);
        this.setupWalls(data);
        this.spawnLogos(data);
        this.setupResizeHandler(data);
    }

    setupRenderer(data) {
        const { container, engine } = data;
        const width = container.offsetWidth;
        const height = container.offsetHeight;

        data.render = Matter.Render.create({
            element: container,
            engine: engine,
            options: {
                width,
                height,
                wireframes: false,
                background: 'transparent'
            }
        });

        const canvas = data.render.canvas;
        canvas.style.position = 'absolute';
        canvas.style.top = '0';
        canvas.style.left = '0';
        canvas.style.pointerEvents = 'none';

        Matter.Render.run(data.render);
        Matter.Runner.run(Matter.Runner.create(), engine);
    }

    setupWalls(data) {
        const { width, height } = data.render.options;
        const ground = Matter.Bodies.rectangle(width / 2, height + 20, width, 40, { isStatic: true });
        const leftWall = Matter.Bodies.rectangle(-20, height / 2, 40, height, { isStatic: true });
        const rightWall = Matter.Bodies.rectangle(width + 20, height / 2, 40, height, { isStatic: true });

        Matter.World.add(data.world, [ground, leftWall, rightWall]);
    }

    setupStaticObstacles(data) {
        const containerRect = data.container.getBoundingClientRect();
        const elements = data.container.querySelectorAll('a');

        elements.forEach(el => {
            const rect = el.getBoundingClientRect();
            const x = rect.left - containerRect.left + rect.width / 2;
            const y = rect.top - containerRect.top + rect.height / 2;

            const body = Matter.Bodies.rectangle(x, y, rect.width, rect.height, {
                isStatic: true,
                render: {
                    fillStyle: 'transparent'
                }
            });

            Matter.World.add(data.world, body);
        });
    }

    spawnLogos(data) {
        const { width } = data.render.options;

        const spawn = () => {
            if (data.logos.length >= data.maxLogos) return;

            const logoWidth = 261;
            const logoHeight = 87;
            const x = Math.random() * (width - logoWidth) + logoWidth / 2;
            const y = -logoHeight;

            const logo = Matter.Bodies.rectangle(x, y, logoWidth, logoHeight, {
                restitution: 0.5,
                friction: 0.6,
                angle: Math.random(),
                render: {
                    sprite: {
                        texture: this.logoImageUrl,
                        yScale: 0.307,
                        xScale: 0.307,
                    }
                }
            });

            data.logos.push(logo);
            Matter.World.add(data.world, logo);
        };

        data.spawnInterval = setInterval(() => {
            spawn();
            if (data.logos.length >= data.maxLogos) {
                clearInterval(data.spawnInterval);
            }
        }, 400);
    }
    
    setupResizeHandler(data) {
        const resize = () => {
            const { container, engine } = data;
            const width = container.offsetWidth;
            const height = container.offsetHeight;
    
            // Resize canvas
            data.render.canvas.width = width;
            data.render.canvas.height = height;
    
            data.render.options.width = width;
            data.render.options.height = height;
    
            const remaining = data.logos;
            Matter.World.clear(engine.world, false);
    
            this.setupWalls(data);
            this.setupStaticObstacles(data);
    
            remaining.forEach(logo => Matter.World.add(engine.world, logo));
        };
    
        window.addEventListener('resize', resize);
    }
}

export default FooterAnimation;
